import '../scss/main.scss';

import { initStickyHeader } from './modules/sticky-header';
import { initHeroMascot } from './modules/hero-mascot';
import { initScrollReveal } from './modules/scroll-reveal';
import { initNewsletter } from './modules/newsletter';
import { initSmoothScroll } from './modules/smooth-scroll';
import { initMobileMenu } from './modules/mobile-menu';
import { initPartnersCarousel } from './modules/partners-carousel';
import { initProjectsCarousel } from './modules/projects-carousel';
import { initEventsCarousel } from './modules/events-carousel';
import { initAccordions } from './modules/accordion';

const init = () => {
  initStickyHeader();
  initHeroMascot();
  initScrollReveal();
  initNewsletter();
  initSmoothScroll();
  initMobileMenu();
  initPartnersCarousel();
  initProjectsCarousel();
  initEventsCarousel();
  initAccordions();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
